import React from 'react';
import { Button } from '../ui/button';

import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Checkbox } from '../ui/checkbox';

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';

import { Shield, CheckCircle, XCircle, User, Building2, FileText, AlertCircle, Users, Loader2, PauseCircle, PlayCircle, TrendingUp, Award, CheckSquare } from 'lucide-react';

import { detectTerritoire } from './gcaConstants';

export default function GestionCoopersModals({ ctx }) {
  const { actionReason, actionType, checklist, handleAction, handleOpenActionDialog, openActionDialog, openDetailModal, processing, selectedCooper, setActionReason, setChecklist, setOpenActionDialog, setOpenDetailModal } = ctx;
  return (
    <>
      {/* ============ DIALOG DÉTAIL ============ */}
      <Dialog open={openDetailModal} onOpenChange={setOpenDetailModal}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-[#0a3d62]">
              <Shield className="h-5 w-5 text-[#DEA900]" />
              Détails du COOPER'S
            </DialogTitle>
          </DialogHeader>
          {selectedCooper && (
            <div className="space-y-5 py-2">
              {/* Entreprise */}
              <section>
                <h4 className="text-[11px] uppercase tracking-wider font-bold text-[#0a3d62] mb-2 flex items-center gap-1.5">
                  <Building2 className="h-3.5 w-3.5 text-[#DEA900]" /> Entreprise
                </h4>
                <div className="grid grid-cols-2 gap-4 bg-slate-50 border border-slate-200 p-4 rounded-xl">
                  <div>
                    <Label className="text-[10px] uppercase tracking-wider text-slate-500">Raison sociale</Label>
                    <p className="font-semibold text-[#0a3d62] mt-0.5">{selectedCooper.entreprise}</p>
                  </div>
                  <div>
                    <Label className="text-[10px] uppercase tracking-wider text-slate-500">SIRET</Label>
                    <p className="font-mono font-semibold text-[#0a3d62] mt-0.5">{selectedCooper.siret}</p>
                  </div>
                  <div className="col-span-2">
                    <Label className="text-[10px] uppercase tracking-wider text-slate-500">Adresse</Label>
                    <p className="text-slate-700 mt-0.5">{selectedCooper.adresse_siege || 'Non renseignée'}</p>
                  </div>
                </div>
              </section>
              {/* Contact */}
              <section>
                <h4 className="text-[11px] uppercase tracking-wider font-bold text-[#0a3d62] mb-2 flex items-center gap-1.5">
                  <User className="h-3.5 w-3.5 text-[#DEA900]" /> Contact
                </h4>
                <div className="grid grid-cols-2 gap-4 bg-slate-50 border border-slate-200 p-4 rounded-xl">
                  <div><Label className="text-[10px] uppercase tracking-wider text-slate-500">Email</Label><p className="font-mono text-sm text-slate-700 mt-0.5">{selectedCooper.user?.email}</p></div>
                  <div><Label className="text-[10px] uppercase tracking-wider text-slate-500">Téléphone</Label><p className="font-mono text-sm text-slate-700 mt-0.5">{selectedCooper.user?.telephone || '—'}</p></div>
                  <div><Label className="text-[10px] uppercase tracking-wider text-slate-500">Nom</Label><p className="text-slate-700 mt-0.5">{selectedCooper.user?.nom} {selectedCooper.user?.prenom}</p></div>
                  <div><Label className="text-[10px] uppercase tracking-wider text-slate-500">Territoire</Label><p className="text-slate-700 mt-0.5">{detectTerritoire(selectedCooper)}</p></div>
                </div>
              </section>
              {/* Performance */}
              <section>
                <h4 className="text-[11px] uppercase tracking-wider font-bold text-[#0a3d62] mb-2 flex items-center gap-1.5">
                  <TrendingUp className="h-3.5 w-3.5 text-[#DEA900]" /> Performance
                </h4>
                <div className="grid grid-cols-3 gap-4 bg-gradient-to-br from-[#0a3d62]/3 to-[#DEA900]/5 border border-slate-200 p-4 rounded-xl">
                  <div className="text-center"><Users className="h-7 w-7 mx-auto text-[#0a3d62] mb-1.5" /><Label className="text-[10px] uppercase tracking-wider text-slate-500">Membres</Label><p className="text-2xl font-bold text-[#0a3d62] tabular-nums">{selectedCooper.membres_assignes || 0}</p></div>
                  <div className="text-center"><FileText className="h-7 w-7 mx-auto text-[#b88600] mb-1.5" /><Label className="text-[10px] uppercase tracking-wider text-slate-500">Dossiers</Label><p className="text-2xl font-bold text-[#b88600] tabular-nums">{selectedCooper.dossiers_traites || 0}</p></div>
                  <div className="text-center"><Award className="h-7 w-7 mx-auto text-emerald-600 mb-1.5" /><Label className="text-[10px] uppercase tracking-wider text-slate-500">Réussite</Label><p className="text-2xl font-bold text-emerald-700 tabular-nums">{selectedCooper.taux_reussite || 0}%</p></div>
                </div>
              </section>
              {/* Checklist */}
              {!selectedCooper.is_validated && (
                <section>
                  <h4 className="text-[11px] uppercase tracking-wider font-bold text-[#b88600] mb-2 flex items-center gap-1.5">
                    <CheckSquare className="h-3.5 w-3.5" /> Checklist de Validation
                  </h4>
                  <div className="space-y-2.5 bg-[#DEA900]/5 border border-[#DEA900]/25 p-4 rounded-xl">
                    {[
                      { id: 'docs', key: 'documents_verifies', label: 'Documents vérifiés (KBIS, RIB, etc.)' },
                      { id: 'siret', key: 'siret_valide', label: 'SIRET valide et actif' },
                      { id: 'statut', key: 'statut_juridique_conforme', label: 'Statut juridique conforme (ESS)' },
                      { id: 'capacite', key: 'capacite_gestion_verifiee', label: 'Capacité de gestion vérifiée' },
                    ].map(({ id, key, label }) => (
                      <div key={id} className="flex items-center gap-3">
                        <Checkbox
                          id={id}
                          checked={checklist[key]}
                          onCheckedChange={(checked) => setChecklist({ ...checklist, [key]: checked })}
                          data-testid={`checklist-${id}`}
                        />
                        <Label htmlFor={id} className="cursor-pointer flex-1 text-sm text-slate-700">{label}</Label>
                      </div>
                    ))}
                  </div>
                </section>
              )}
            </div>
          )}
          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => setOpenDetailModal(false)}>Fermer</Button>
            {selectedCooper && !selectedCooper.is_validated && (
              <>
                <Button onClick={() => { setOpenDetailModal(false); handleOpenActionDialog(selectedCooper, 'reject'); }} variant="destructive">
                  <XCircle className="h-4 w-4 mr-2" /> Rejeter
                </Button>
                <Button onClick={() => { setOpenDetailModal(false); handleOpenActionDialog(selectedCooper, 'validate'); }} className="bg-emerald-600 hover:bg-emerald-700">
                  <CheckCircle className="h-4 w-4 mr-2" /> Valider
                </Button>
              </>
            )}
            {selectedCooper && selectedCooper.is_validated && selectedCooper.is_active && (
              <Button onClick={() => { setOpenDetailModal(false); handleOpenActionDialog(selectedCooper, 'suspend'); }} variant="outline" className="border-rose-500 text-rose-600">
                <PauseCircle className="h-4 w-4 mr-2" /> Suspendre
              </Button>
            )}
            {selectedCooper && !selectedCooper.is_active && (
              <Button onClick={() => { setOpenDetailModal(false); handleOpenActionDialog(selectedCooper, 'activate'); }} className="bg-[#0a3d62] hover:bg-[#0c4a78]">
                <PlayCircle className="h-4 w-4 mr-2" /> Réactiver
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* ============ DIALOG ACTION ============ */}
      <Dialog open={openActionDialog} onOpenChange={setOpenActionDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-[#0a3d62]">
              {actionType === 'validate' && 'Valider le COOPER\'S'}
              {actionType === 'suspend' && 'Suspendre le COOPER\'S'}
              {actionType === 'activate' && 'Réactiver le COOPER\'S'}
              {actionType === 'reject' && 'Rejeter le COOPER\'S'}
            </DialogTitle>
          </DialogHeader>
          {selectedCooper && (
            <div className="space-y-4 py-2">
              <div className="bg-slate-50 border border-slate-200 p-3 rounded-lg">
                <p className="font-semibold text-[#0a3d62]">{selectedCooper.entreprise}</p>
                <p className="text-slate-600 font-mono text-xs">{selectedCooper.siret}</p>
              </div>
              {actionType === 'validate' && (
                <div className={`p-4 rounded-lg border ${Object.values(checklist).every(v => v) ? 'bg-emerald-50 border-emerald-200' : 'bg-[#DEA900]/8 border-[#DEA900]/30'}`}>
                  {Object.values(checklist).every(v => v) ? (
                    <div className="flex items-center gap-2 text-emerald-700"><CheckCircle className="h-5 w-5" /><span className="font-medium">Tous les critères sont validés</span></div>
                  ) : (
                    <div className="flex items-center gap-2 text-[#b88600]"><AlertCircle className="h-5 w-5" /><span className="font-medium">Veuillez cocher tous les critères</span></div>
                  )}
                </div>
              )}
              {['suspend', 'reject'].includes(actionType) && (
                <div>
                  <Label className="text-[#0a3d62] font-semibold">Raison *</Label>
                  <Textarea
                    value={actionReason}
                    onChange={(e) => setActionReason(e.target.value)}
                    placeholder="Indiquez la raison…"
                    rows={4}
                    className="mt-1.5"
                    data-testid="action-reason-input"
                  />
                </div>
              )}
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpenActionDialog(false)} disabled={processing}>Annuler</Button>
            <Button
              onClick={handleAction}
              disabled={processing}
              data-testid="action-confirm-btn"
              className={
                actionType === 'validate' ? 'bg-emerald-600 hover:bg-emerald-700' :
                actionType === 'activate' ? 'bg-[#0a3d62] hover:bg-[#0c4a78]' : ''
              }
              variant={['suspend', 'reject'].includes(actionType) ? 'destructive' : 'default'}
            >
              {processing ? (
                <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Traitement…</>
              ) : (
                <>
                  {actionType === 'validate' && <><CheckCircle className="h-4 w-4 mr-2" />Valider</>}
                  {actionType === 'suspend' && <><PauseCircle className="h-4 w-4 mr-2" />Suspendre</>}
                  {actionType === 'activate' && <><PlayCircle className="h-4 w-4 mr-2" />Réactiver</>}
                  {actionType === 'reject' && <><XCircle className="h-4 w-4 mr-2" />Rejeter</>}
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
